<template>
  <div class="page-box">
    <!-- 头部标题 +++++++++++++++++++++++++++++++++++++++++ -->
    <div class="dtl-head">
      <div class="pageTit c-breadcrumb">
        <el-breadcrumb separator=">" class="theme-default">
          <el-breadcrumb-item :to="{ path: `/newriskmanage` }">{{ $t('head.applyWind') }}</el-breadcrumb-item>
          <el-breadcrumb-item v-if="source==0" :to="{ path: `/rongzisqs?id=${id}` }">{{ $t('rongzisqs.titleName') }}</el-breadcrumb-item>
          <el-breadcrumb-item v-else-if="source==1" :to="{ path: `/financingFundDetail?in_id=${id}` }">{{ $t('rongzisqs.titleName') }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('newrisk.risk_assessment') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!--流水号-->
      <p class="top-tit" style="text-align:right;padding-right:90px"><span>{{ $t('loan.financingNum') }}：</span>
        <span >{{ id }}</span>
      </p>
      <!-- 分割图片 -->
      <img class="c-divider" src="../../assets/images/common/documentSeparation.png" alt="">
    </div>
    <el-form ref="ruleForm" :model="jsonData" :rules="rules" class="box-item top" style="margin-top:-5px;margin-bottom:80px;padding:0">
      <div class="company-name" @click="openkyc()">{{ riskType==1?infoDataDetail.cicFinancingApplyDraftSnapshotVO.buyerCompanyName:infoDataDetail.cicFinancingApplyDraftSnapshotVO.sellerCompanyName }}</div>
      <div style="margin-top:10px;font-size:16px;margin-bottom:20px;corlor:#333;padding-left:90px">{{ $t('newrisk.risk_assessment') }}</div>
      <el-tabs type="border-card" class="theme-default" style="background:none; ">

        <el-tab-pane :label="$t('newrisk.quantitative_analysis')" style="padding: 0" >
          <z-collapse :title="$t('newrisk.performance')">
            <div class="collapse-box">
              <div class="left-box">
                <span class="tit">{{ $t('newrisk.net_profit_margin') }}</span>
                <div class="core">
                  <span class="s1">{{ $t('newrisk.score_tatal') }}</span>
                  <span class="s2">{{ grad1() || 0 }}</span>
                  <span class="s3" >/4.5</span>
                </div>
              </div>
              <div class="right-box">
                <div class="item">
                  <div class="tit">{{ $t('newrisk.net_profit') }}</div>
                  <el-form-item prop="net_profit">
                    <div class="model-input">{{ jsonData.net_profit }}</div>
                    <!-- <el-input v-model.trim="jsonData.net_profit" :placeholder="$t('financingFundList.enterPlaceHolder')" clearable maxlength="18" @blur="numberBlur('net_profit',2)" @input="moneyInput('net_profit',1)"/> -->
                  </el-form-item>

                </div>
                <div class="item">
                  <div class="tit">{{ $t('newrisk.total_sales') }}</div>
                  <el-form-item prop="total_sales">
                    <div class="model-input">{{ jsonData.total_sales }}</div>
                    <!-- <el-input v-model.trim="jsonData.total_sales" :placeholder="$t('financingFundList.enterPlaceHolder')" clearable maxlength="17" @blur="numberBlur('total_sales',2)" @input="moneyInput('total_sales')"/> -->
                  </el-form-item>
                </div>
                <div class="item">
                  <div class="tit">{{ $t('newrisk.result') }}</div>
                  <div class="model-input">{{ result1() }}</div>
                  <!-- <el-input :value="result1()" disabled /> -->
                </div>
                <div class="item">
                  <div class="tit">{{ $t('newrisk.grading') }}</div>
                  <div class="model-input">{{ grad1() }}</div>
                  <!-- <el-input :value="grad1()" disabled /> -->
                </div>
              </div>
            </div>
          </z-collapse>
          <z-collapse :title="$t('newrisk.leverage')">
            <div class="collapse-box">
              <div class="left-box">
                <span class="tit">{{ $t('newrisk.total_tangible_worth') }}</span>
              </div>
              <div class="right-box">
                <div class="item">
                  <div class="tit">{{ $t('newrisk.total_liabilities') }}</div>
                  <el-form-item prop="total_liabilities">
                    <div class="model-input">{{ jsonData.total_liabilities }}</div>
                    <!-- <el-input v-model.trim="jsonData.total_liabilities" :placeholder="$t('financingFundList.enterPlaceHolder')" clearable maxlength="17" @blur="numberBlur('total_liabilities',2)" @input="moneyInput('total_liabilities')"/> -->
                  </el-form-item>
                </div>
                <div class="item">
                  <div class="tit">{{ $t('newrisk.tangible_worth') }}</div>
                  <el-form-item prop="tangible_net_worth">
                    <div class="model-input">{{ jsonData.tangible_net_worth }}</div>
                    <!-- <el-input v-model.trim="jsonData.tangible_net_worth" :placeholder="$t('financingFundList.enterPlaceHolder')" clearable maxlength="17" @blur="numberBlur('tangible_net_worth',2)" @input="moneyInput('tangible_net_worth')"/> -->
                  </el-form-item>
                </div>
                <div class="item">
                  <div class="tit">{{ $t('newrisk.result') }}</div>
                  <div class="model-input">{{ result2() }}</div>
                  <!-- <el-input :value="result2()" disabled/> -->
                </div>
                <div class="item">
                  <div class="tit">{{ $t('newrisk.grading') }}</div>
                  <div class="model-input">{{ grad2() }}</div>
                  <!-- <el-input :value="grad2()" disabled/> -->
                </div>
              </div>
            </div>
            <div class="collapse-box mt--20">
              <div class="left-box">
                <span class="tit">{{ $t('newrisk.tangible_total') }}</span>
                <div class="core">
                  <span class="s1">{{ $t('newrisk.score_tatal') }}</span>
                  <span class="s2">{{ (grad2()+grad3()) || 0 }}</span>
                  <span class="s3" >/13</span>
                </div>
              </div>
              <div class="right-box">
                <div class="item">
                  <div class="tit">{{ $t('newrisk.tangible_worth') }}</div>
                  <el-form-item prop="tangible_net_worth_2">
                    <div class="model-input">{{ jsonData.tangible_net_worth_2 }}</div>
                    <!-- <el-input v-model.trim="jsonData.tangible_net_worth_2" :placeholder="$t('financingFundList.enterPlaceHolder')" clearable maxlength="17" @blur="numberBlur('tangible_net_worth_2',2)" @input="moneyInput('tangible_net_worth_2')"/> -->
                  </el-form-item>
                </div>
                <div class="item">
                  <div class="tit">{{ $t('newrisk.interest_expense') }}</div>
                  <el-form-item prop="interest_expense">
                    <div class="model-input">{{ jsonData.interest_expense }}</div>
                    <!-- <el-input v-model.trim="jsonData.interest_expense" :placeholder="$t('financingFundList.enterPlaceHolder')" clearable maxlength="17" @blur="numberBlur('interest_expense',2)" @input="moneyInput('interest_expense')"/> -->
                  </el-form-item>
                </div>
                <div class="item">
                  <div class="tit">{{ $t('newrisk.long_debt') }}</div>
                  <el-form-item prop="long_term_debt">
                    <div class="model-input">{{ jsonData.long_term_debt }}</div>
                    <!-- <el-input v-model.trim="jsonData.long_term_debt" :placeholder="$t('financingFundList.enterPlaceHolder')" clearable maxlength="17" @blur="numberBlur('long_term_debt',2)" @input="moneyInput('long_term_debt')"/> -->
                  </el-form-item>
                </div>
                <div class="item  mt-20">
                  <div class="tit">{{ $t('newrisk.short_debt') }}</div>
                  <el-form-item prop="short_term_debt">
                    <div class="model-input">{{ jsonData.short_term_debt }}</div>
                    <!-- <el-input v-model.trim="jsonData.short_term_debt" :placeholder="$t('financingFundList.enterPlaceHolder')" clearable maxlength="17" @blur="numberBlur('short_term_debt',2)" @input="moneyInput('short_term_debt')"/> -->
                  </el-form-item>
                </div>
                <div class="item mt-20">
                  <div class="tit">{{ $t('newrisk.result') }}</div>
                  <div class="model-input">{{ result3() }}</div>
                  <!-- <el-input :value="result3()" disabled/> -->
                </div>
                <div class="item mt-20">
                  <div class="tit">{{ $t('newrisk.grading') }}</div>
                  <div class="model-input">{{ grad3() }}</div>
                  <!-- <el-input :value="grad3()" disabled/> -->
                </div>
              </div>
            </div>
          </z-collapse>
          <z-collapse :title="$t('newrisk.cashflow')">
            <div class="collapse-box">
              <div class="left-box">
                <span class="tit">{{ $t('newrisk.cash_after_total') }}</span>
                <div class="core">
                  <span class="s1">{{ $t('newrisk.score_tatal') }}</span>
                  <span class="s2">{{ grad4() || 0 }}</span>
                  <span class="s3" >/10</span>
                </div>
              </div>
              <div class="right-box">
                <div class="item">
                  <div class="tit">{{ $t('newrisk.cash_after') }}</div>
                  <el-form-item prop="cash_after_operation">
                    <div class="model-input">{{ jsonData.cash_after_operation }}</div>
                    <!-- <el-input v-model.trim="jsonData.cash_after_operation" :placeholder="$t('financingFundList.enterPlaceHolder')" clearable maxlength="17" @blur="numberBlur('cash_after_operation',2)" @input="moneyInput('cash_after_operation')"/> -->
                  </el-form-item>
                </div>
                <div class="item">
                  <div class="tit">{{ $t('newrisk.interest_expense') }}</div>
                  <el-form-item prop="cash_interest_expense">
                    <div class="model-input">{{ jsonData.cash_interest_expense }}</div>
                    <!-- <el-input v-model.trim="jsonData.cash_interest_expense" :placeholder="$t('financingFundList.enterPlaceHolder')" clearable maxlength="17" @blur="numberBlur('cash_interest_expense',2)" @input="moneyInput('cash_interest_expense')"/> -->
                  </el-form-item>
                </div>
                <div class="item">
                  <div class="tit">{{ $t('newrisk.long_debt') }}</div>
                  <el-form-item prop="cash_long_term_debt">
                    <div class="model-input">{{ jsonData.cash_long_term_debt }}</div>
                    <!-- <el-input v-model.trim="jsonData.cash_long_term_debt" :placeholder="$t('financingFundList.enterPlaceHolder')" clearable maxlength="17" @blur="numberBlur('cash_long_term_debt',2)" @input="moneyInput('cash_long_term_debt')"/> -->
                  </el-form-item>
                </div>
                <div class="item mt-20">
                  <div class="tit">{{ $t('newrisk.short_debt') }}</div>
                  <el-form-item prop="cash_short_term_debt">
                    <div class="model-input">{{ jsonData.cash_short_term_debt }}</div>
                    <!-- <el-input v-model.trim="jsonData.cash_short_term_debt" :placeholder="$t('financingFundList.enterPlaceHolder')" clearable maxlength="17" @blur="numberBlur('cash_short_term_debt',2)" @input="moneyInput('cash_short_term_debt')"/> -->
                  </el-form-item>
                </div>
                <div class="item mt-20">
                  <div class="tit">{{ $t('newrisk.result') }}</div>
                  <div class="model-input">{{ result4() }}</div>
                  <!-- <el-input :value="result4()" disabled/> -->
                </div>
                <div class="item mt-20">
                  <div class="tit">{{ $t('newrisk.grading') }}</div>
                  <div class="model-input">{{ grad4() }}</div>
                  <!-- <el-input :value="grad4()" disabled/> -->
                </div>
              </div>
            </div>
          </z-collapse>
          <z-collapse :title="$t('newrisk.activity')">
            <div class="collapse-box">
              <div class="left-box">
                <span class="tit">{{ $t('newrisk.sales_total') }}</span>
              </div>
              <div class="right-box">
                <div class="item">
                  <div class="tit">{{ $t('newrisk.sales') }}</div>
                  <el-form-item prop="activity_sales">
                    <div class="model-input">{{ jsonData.activity_sales }}</div>
                    <!-- <el-input v-model.trim="jsonData.activity_sales" :placeholder="$t('financingFundList.enterPlaceHolder')" clearable maxlength="17" @blur="numberBlur('activity_sales',2)" @input="moneyInput('activity_sales')"/> -->
                  </el-form-item>
                </div>
                <div class="item">
                  <div class="tit">{{ $t('newrisk.total_assets') }}</div>
                  <el-form-item prop="activity_total_assets">
                    <div class="model-input">{{ jsonData.activity_total_assets }}</div>
                    <!-- <el-input v-model.trim="jsonData.activity_total_assets" :placeholder="$t('financingFundList.enterPlaceHolder')" clearable maxlength="17" @blur="numberBlur('activity_total_assets',2)" @input="moneyInput('activity_total_assets')"/> -->
                  </el-form-item>
                </div>
                <div class="item">
                  <div class="tit">{{ $t('newrisk.result') }}</div>
                  <div class="model-input">{{ result5() }}</div>
                  <!-- <el-input :value="result5()" disabled /> -->
                </div>
                <div class="item">
                  <div class="tit">{{ $t('newrisk.grading') }}</div>
                  <div class="model-input">{{ grad5() }}</div>
                  <!-- <el-input :value="grad5()" disabled /> -->
                </div>
              </div>
            </div>
            <div class="collapse-box mt--20">
              <div class="left-box">
                <span class="tit">{{ $t('newrisk.sales_growth') }}</span>
                <div class="core">
                  <span class="s1">{{ $t('newrisk.score_tatal') }}</span>
                  <span class="s2">{{ (grad5()+grad6()) || 0 }}</span>
                  <span class="s3" >/8.5</span>
                </div>
              </div>
              <div class="right-box">
                <div class="item">
                  <div class="tit">{{ $t('newrisk.current_sales') }}</div>
                  <el-form-item prop="activity_sales_thisyear">
                    <div class="model-input">{{ jsonData.activity_sales_thisyear }}</div>
                    <!-- <el-input v-model.trim="jsonData.activity_sales_thisyear" :placeholder="$t('financingFundList.enterPlaceHolder')" clearable maxlength="17" @blur="numberBlur('activity_sales_thisyear',2)" @input="moneyInput('activity_sales_thisyear')"/> -->
                  </el-form-item>
                </div>
                <div class="item">
                  <div class="tit">{{ $t('newrisk.previous_sales') }}</div>
                  <el-form-item prop="activity_sales_lastyear">
                    <div class="model-input">{{ jsonData.activity_sales_lastyear }}</div>
                    <!-- <el-input v-model.trim="jsonData.activity_sales_lastyear" :placeholder="$t('financingFundList.enterPlaceHolder')" clearable maxlength="17" @blur="numberBlur('activity_sales_lastyear',2)" @input="moneyInput('activity_sales_lastyear')"/> -->
                  </el-form-item>
                </div>

                <div class="item">
                  <div class="tit">{{ $t('newrisk.result') }}</div>
                  <div class="model-input">{{ result6() }}</div>
                  <!-- <el-input :value="result6()" disabled /> -->
                </div>
                <div class="item">
                  <div class="tit">{{ $t('newrisk.grading') }}</div>
                  <div class="model-input">{{ grad6() }}</div>
                  <!-- <el-input :value="grad6()" disabled /> -->
                </div>
              </div>
            </div>
          </z-collapse>
          <z-collapse :title="$t('newrisk.liquidity')">
            <div class="collapse-box">
              <div class="left-box">
                <span class="tit">{{ $t('newrisk.liquid_liabilities') }}</span>
                <div class="core">
                  <span class="s1">{{ $t('newrisk.score_tatal') }}</span>
                  <span class="s2">{{ grad7() || 0 }}</span>
                  <span class="s3" >/11</span>
                </div>
              </div>
              <div class="right-box">
                <div class="item">
                  <div class="tit">{{ $t('newrisk.liquid_assets') }}</div>
                  <el-form-item prop="liquid_assets">
                    <div class="model-input">{{ jsonData.liquid_assets }}</div>
                    <!-- <el-input v-model.trim="jsonData.liquid_assets" :placeholder="$t('financingFundList.enterPlaceHolder')" clearable maxlength="17" @blur="numberBlur('liquid_assets',2)" @input="moneyInput('liquid_assets')"/> -->
                  </el-form-item>
                </div>
                <div class="item">
                  <div class="tit">{{ $t('newrisk.current_liabilities') }}</div>
                  <el-form-item prop="current_liabilities">
                    <div class="model-input">{{ jsonData.current_liabilities }}</div>
                    <!-- <el-input v-model.trim="jsonData.current_liabilities" :placeholder="$t('financingFundList.enterPlaceHolder')" clearable maxlength="17" @blur="numberBlur('current_liabilities',2)" @input="moneyInput('current_liabilities')"/> -->
                  </el-form-item>
                </div>
                <div class="item">
                  <div class="tit">{{ $t('newrisk.result') }}</div>
                  <div class="model-input">{{ result7() }}</div>
                  <!-- <el-input :value="result7()" disabled /> -->
                </div>
                <div class="item">
                  <div class="tit">{{ $t('newrisk.grading') }}</div>
                  <div class="model-input">{{ grad7() }}</div>
                  <!-- <el-input :value="grad7()" disabled /> -->
                </div>
              </div>
            </div>
          </z-collapse>
          <z-collapse :title="$t('newrisk.size')">
            <div class="collapse-box">
              <div class="left-box">
                <span class="tit">{{ $t('newrisk.tangible_million') }}</span>
                <div class="core">
                  <span class="s1">{{ $t('newrisk.score_tatal') }}</span>
                  <span class="s2">{{ grad8() || 0 }}</span>
                  <span class="s3" >/3</span>
                </div>
              </div>
              <div class="right-box">
                <div class="item">
                  <div class="tit">{{ $t('newrisk.tangible_worth') }}</div>
                  <el-form-item prop="size_net_worth">
                    <div class="model-input">{{ jsonData.size_net_worth }}</div>
                    <!-- <el-input v-model.trim="jsonData.size_net_worth" :placeholder="$t('financingFundList.enterPlaceHolder')" clearable maxlength="17" @blur="numberBlur('size_net_worth',2)" @input="moneyInput('size_net_worth')"/> -->
                  </el-form-item>
                </div>

                <div class="item">
                  <div class="tit">{{ $t('newrisk.grading') }}</div>
                  <div class="model-input">{{ grad8() }}</div>
                  <!-- <el-input :value="grad8()" disabled /> -->
                </div>
              </div>
            </div>
          </z-collapse>
        </el-tab-pane>

        <el-tab-pane :label="$t('newrisk.qualitative_analysis')" style="padding: 0" >
          <div class="collapse-box2">
            <div class="left-box">
              <span class="tit">{{ $t('newrisk.management_quality') }}</span>
              <div class="core">
                <span class="s1">{{ $t('newrisk.score_tatal') }}</span>
                <span class="s2">{{ grad9() }}</span>
                <span class="s3" >/15</span>
              </div>
            </div>
            <div class="right-box">
              <div class="item">
                <div class="tit">{{ $t('newrisk.experience') }}</div>
                <el-form-item prop="experience.value" >
                  <div class="model-input-2">{{ jsonData.experience.value }}</div>
                  <div class="model-input-3">
                    <el-popover
                      ref="popover1"
                      popper-class="toList-popper"
                      placement="bottom-start"
                      trigger="hover">
                      <span>{{ jsonData.experience.text }}</span>
                      <span slot="reference">{{ jsonData.experience.text }}</span>
                    </el-popover>
                  </div>

                  <!-- <el-input v-model="jsonData.experience.value" class="input-1" placeholder="≤4.5" @input="moneyInput2('experience',4.5)" /> -->

                  <!-- <el-input v-model="jsonData.experience.text" class="input-2" type="textarea" autosize/> -->
                </el-form-item>
              </div>
              <div class="item mt-10">
                <div class="tit">{{ $t('newrisk.management_strength') }}</div>
                <el-form-item prop="management_strength.value">
                  <div class="model-input-2">{{ jsonData.management_strength.value }}</div>
                  <div class="model-input-3">
                    <el-popover
                      ref="popover2"
                      popper-class="toList-popper"
                      placement="bottom-start"
                      trigger="hover">
                      <span>{{ jsonData.management_strength.text }}</sp>
                        <span slot="reference">{{ jsonData.management_strength.text }}</span>
                    </span></el-popover>
                  </div>
                  <!-- <el-input v-model="jsonData.management_strength.value" class="input-1" placeholder="≤3" @input="moneyInput2('management_strength',3)" />
                  <el-input v-model="jsonData.management_strength.text" class="input-2" type="textarea" autosize/> -->
                </el-form-item>
              </div>
              <div class="item mt-10">
                <div class="tit">{{ $t('newrisk.controls') }}</div>
                <el-form-item prop="controls.value">
                  <div class="model-input-2">{{ jsonData.controls.value }}</div>
                  <div class="model-input-3">
                    <el-popover
                      ref="popover3"
                      popper-class="toList-popper"
                      placement="bottom-start"
                      trigger="hover">
                      <span>{{ jsonData.controls.text }}</span>
                      <span slot="reference" >{{ jsonData.controls.text }}</span>
                    </el-popover>
                  </div>
                  <!-- <el-input v-model="jsonData.controls.value" class="input-1" placeholder="≤4.5" @input="moneyInput2('controls',4.5)" />

                  <el-input v-model="jsonData.controls.text" class="input-2" type="textarea" autosize/> -->
                </el-form-item>
              </div>
              <div class="item mt-10">
                <div class="tit">{{ $t('newrisk.account_conduct') }}</div>
                <el-form-item prop="account_conduct.value">
                  <div class="model-input-2">{{ jsonData.account_conduct.value }}</div>
                  <div class="model-input-3">
                    <el-popover
                      ref="popover4"
                      popper-class="toList-popper"
                      placement="bottom-start"
                      trigger="hover">
                      <span>{{ jsonData.account_conduct.text }}</span>
                      <span slot="reference" >{{ jsonData.account_conduct.text }}</span>
                    </el-popover>
                  </div>
                  <!-- <el-input v-model="jsonData.account_conduct.value" class="input-1" placeholder="≤4.5" @input="moneyInput2('account_conduct',4.5)" />
                  <el-input v-model="jsonData.account_conduct.text" class="input-2" type="textarea" autosize/> -->
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="collapse-box2">
            <div class="left-box">
              <span class="tit">{{ $t('newrisk.industry') }}</span>
              <div class="core">
                <span class="s1">{{ $t('newrisk.score_tatal') }}</span>
                <span class="s2">{{ grad10() }}</span>
                <span class="s3" >/25</span>
              </div>
            </div>
            <div class="right-box">
              <div class="item">
                <div class="tit">{{ $t('newrisk.industry_outlook') }}</div>
                <el-form-item prop="industry_outlook.value">
                  <div class="model-input-2">{{ jsonData.industry_outlook.value }}</div>
                  <div class="model-input-3">
                    <el-popover
                      ref="popover5"
                      popper-class="toList-popper"
                      placement="bottom-start"
                      trigger="hover">
                      <span>{{ jsonData.industry_outlook.text }}</span>
                      <span slot="reference" >{{ jsonData.industry_outlook.text }}</span>
                    </el-popover>
                  </div>
                  <!-- <el-input v-model="jsonData.industry_outlook.value" class="input-1" placeholder="≤10" @input="moneyInput2('industry_outlook',10)" />
                  <el-input v-model="jsonData.industry_outlook.text" class="input-2" maxlength="2000" type="textarea" autosize/> -->
                </el-form-item>
              </div>
              <div class="item mt-10">
                <div class="tit">{{ $t('newrisk.market_position') }}</div>
                <el-form-item prop="market_position.value">
                  <div class="model-input-2">{{ jsonData.market_position.value }}</div>
                  <div class="model-input-3">
                    <el-popover
                      ref="popover6"
                      popper-class="toList-popper"
                      placement="bottom-start"
                      trigger="hover">
                      <span>{{ jsonData.market_position.text }}</span>
                      <span slot="reference" >{{ jsonData.market_position.text }}</span>
                    </el-popover>
                  </div>
                  <!-- <el-input v-model="jsonData.market_position.value" class="input-1" placeholder="≤2.5" @input="moneyInput2('market_position',2.5)" />
                  <el-input v-model="jsonData.market_position.text" class="input-2" maxlength="2000" type="textarea" autosize/> -->
                </el-form-item>
              </div>
              <div class="item mt-10">
                <div class="tit">{{ $t('newrisk.barriers_entry') }}</div>
                <el-form-item prop="barriers_to_entry.value">
                  <div class="model-input-2">{{ jsonData.barriers_to_entry.value }}</div>
                  <div class="model-input-3">
                    <el-popover
                      ref="popover7"
                      popper-class="toList-popper"
                      placement="bottom-start"
                      trigger="hover">
                      <span>{{ jsonData.barriers_to_entry.text }}</span>
                      <span slot="reference" >{{ jsonData.barriers_to_entry.text }}</span>
                    </el-popover>
                  </div>
                  <!-- <el-input v-model="jsonData.barriers_to_entry.value" class="input-1" placeholder="≤2.5" @input="moneyInput2('barriers_to_entry',2.5)" />
                  <el-input v-model="jsonData.barriers_to_entry.text" class="input-2" maxlength="2000" type="textarea" autosize/> -->
                </el-form-item>
              </div>
              <div class="item mt-10">
                <div class="tit">{{ $t('newrisk.cyclicality') }}</div>
                <el-form-item prop="cyclicality.value">
                  <div class="model-input-2">{{ jsonData.cyclicality.value }}</div>
                  <div class="model-input-3">
                    <el-popover
                      ref="popover8"
                      popper-class="toList-popper"
                      placement="bottom-start"
                      trigger="hover">
                      <span>{{ jsonData.cyclicality.text }}</span>
                      <span slot="reference" >{{ jsonData.cyclicality.text }}</span>
                    </el-popover>
                  </div>
                  <!-- <el-input v-model="jsonData.cyclicality.value" class="input-1" placeholder="≤3.75" @input="moneyInput2('cyclicality',3.75)" />
                  <el-input v-model="jsonData.cyclicality.text" class="input-2" maxlength="2000" type="textarea" autosize/> -->
                </el-form-item>
              </div>
              <div class="item mt-10">
                <div class="tit">{{ $t('newrisk.risk_flexbility') }}</div>
                <el-form-item prop="risk_flexibility.value">
                  <div class="model-input-2">{{ jsonData.risk_flexibility.value }}</div>
                  <div class="model-input-3">
                    <el-popover
                      ref="popover9"
                      popper-class="toList-popper"
                      placement="bottom-start"
                      trigger="hover">
                      <span>{{ jsonData.risk_flexibility.text }}</span>
                      <span slot="reference" >{{ jsonData.risk_flexibility.text }}</span>
                    </el-popover>
                  </div>
                  <!-- <el-input v-model="jsonData.risk_flexibility.value" class="input-1" placeholder="≤3.75" @input="moneyInput2('risk_flexibility',3.75)" />
                  <el-input v-model="jsonData.risk_flexibility.text" class="input-2" maxlength="2000" type="textarea" autosize/> -->
                </el-form-item>
              </div>
              <div class="item mt-10">
                <div class="tit">{{ $t('newrisk.dependencies') }}</div>
                <el-form-item prop="dependencies.value">
                  <div class="model-input-2">{{ jsonData.dependencies.value }}</div>
                  <div class="model-input-3">
                    <el-popover
                      ref="popover10"
                      popper-class="toList-popper"
                      placement="bottom-start"
                      trigger="hover">
                      <span>{{ jsonData.dependencies.text }}</span>
                      <span slot="reference" >{{ jsonData.dependencies.text }}</span>
                    </el-popover>
                  </div>
                  <!-- <el-input v-model="jsonData.dependencies.value" class="input-1" placeholder="≤2.5" @input="moneyInput2('dependencies',2.5)" />
                  <el-input v-model="jsonData.dependencies.text" class="input-2" maxlength="2000" type="textarea" autosize/> -->
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="collapse-box2">
            <div class="left-box">
              <span class="tit">{{ $t('newrisk.other_factors') }}</span>
              <div class="core">
                <span class="s1">{{ $t('newrisk.score_tatal') }}</span>
                <span class="s2">{{ grad11() }}</span>
                <span class="s3" >/10</span>
              </div>
            </div>
            <div class="right-box">
              <div class="item">
                <div class="tit">{{ $t('newrisk.litigation') }}</div>
                <el-form-item prop="litigation.value">
                  <div class="model-input-2">{{ jsonData.litigation.value }}</div>
                  <div class="model-input-3">
                    <el-popover
                      ref="popover11"
                      popper-class="toList-popper"
                      placement="bottom-start"
                      trigger="hover">
                      <span>{{ jsonData.litigation.text }}</span>
                      <span slot="reference" >{{ jsonData.litigation.text }}</span>
                    </el-popover>
                  </div>
                  <!-- <el-input v-model="jsonData.litigation.value" class="input-1" placeholder="≤1" @input="moneyInput2('litigation',1)" />
                  <el-input v-model="jsonData.litigation.text" class="input-2" maxlength="2000" type="textarea" autosize/> -->
                </el-form-item>
              </div>
              <div class="item mt-10">
                <div class="tit">{{ $t('newrisk.fx') }}</div>
                <el-form-item prop="fx.value">
                  <div class="model-input-2">{{ jsonData.fx.value }}</div>
                  <div class="model-input-3">
                    <el-popover
                      ref="popover12"
                      popper-class="toList-popper"
                      placement="bottom-start"
                      trigger="hover">
                      <span>{{ jsonData.fx.text }}</span>
                      <span slot="reference" >{{ jsonData.fx.text }}</span>
                    </el-popover>
                  </div>
                  <!-- <el-input v-model="jsonData.fx.value" class="input-1" placeholder="≤5" @input="moneyInput2('fx',5)" />
                  <el-input v-model="jsonData.fx.text" class="input-2" maxlength="2000" type="textarea" autosize/> -->
                </el-form-item>
              </div>
              <div class="item mt-10">
                <div class="tit">{{ $t('newrisk.country') }}</div>
                <el-form-item prop="country.value">
                  <div class="model-input-2">{{ jsonData.country.value }}</div>
                  <div class="model-input-3">
                    <el-popover
                      ref="popover13"
                      popper-class="toList-popper"
                      placement="bottom-start"
                      trigger="hover">
                      <span>{{ jsonData.country.text }}</span>
                      <span slot="reference" >{{ jsonData.country.text }}</span>
                    </el-popover>
                  </div>
                  <!-- <el-input v-model="jsonData.country.value" class="input-1" placeholder="≤4" @input="moneyInput2('experience',4)" />
                  <el-input v-model="jsonData.country.text" class="input-2" maxlength="2000" type="textarea" autosize/> -->
                </el-form-item>
              </div>

            </div>
          </div>
          <div class="tip1">{{ $t('newrisk.market') }}:</div>
          <div class="tip2">
            <span class="text-pre" v-html="jsonData.market"/>
          </div>

        </el-tab-pane>
        <el-tab-pane :label="$t('newrisk.risk_assessment')" style="padding: 0">
          <div class="tab-3">
            <div class="score-box">{{ ratingLevel() }}</div>
            <div style="margin-left:30px;">
              <div style="font-size: 16px;margin-bottom:20px;color:#333333">{{ $t('newrisk.risk_assessment') }}</div>
              <div style="font-size: 14px;">
                <span style="color: #666666;">{{ $t('newrisk.risk_advice') }}:</span>
                <span v-if="suggest==1" >{{ $t('newrisk.p_financing') }}</span>
                <span v-if="suggest==2">{{ $t('newrisk.r_financing') }}</span>
                <span v-if="suggest==3">{{ $t('newrisk.pr_financing') }}</span>
              </div>
              <div class="row" style="font-size: 14px;margin-top:20px;margin-bottom:40px;">
                <span class="s-1">{{ rating_type }}{{ rating_value }}:</span>
                <span class="s-2 text-pre" v-html="remark"/>
              </div>

            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-form>

    <div class="whiteFixed">
      <!--打回，提交，转移-->
      <!-- <Tbutton style="margin:0 10px;min-width:150px;display: inline-block;" @click.native="">{{ $t('btns.repulse') }}</Tbutton> -->
      <el-button
        class="pool-btn-default"
        style="margin:0 10px;"
        @click="$router.go(-1)"
      >{{ $t("btns.back") }}</el-button>

    </div>
    <el-dialog
      :visible.sync="kycDialog"
      :title="$t('newrisk.user_profile')"
      width="720px"
    >
      <div style="padding:30px 40px;" class="profile-div">
        <el-row style="margin-bottom:20px;">
          <el-col :span="8">{{ $t('newrisk.kyc_1') }}：</el-col>
          <el-col v-if="kycInfo.businessFileList" :span="16" style="">
            <a v-for="(v,i) in kycInfo.businessFileList" :key="i" :href="v.relativeUrl" target="_blank" style="display: block;color:#7996F5;"><i :class="getFileType(v.fileName)" class="file-icon"/>{{ v.fileName }}</a>
          </el-col>
        </el-row>
        <el-row style="margin-bottom:20px;">
          <el-col :span="8">{{ $t('newrisk.kyc_2') }}：</el-col>
          <el-col v-if="kycInfo.corportateFileList" :span="16" style="color:#7996F5;">
            <a v-for="(v,i) in kycInfo.corportateFileList" :key="i" :href="v.relativeUrl" target="_blank" style="display: block;color:#7996F5;"><i :class="getFileType(v.fileName)" class="file-icon"/>{{ v.fileName }}</a>
          </el-col>
        </el-row>
        <el-row style="margin-bottom:20px;">
          <el-col :span="8">{{ $t('newrisk.kyc_3') }}：</el-col>
          <el-col v-if="kycInfo.financialFileList" :span="16" style="color:#7996F5;">
            <a v-for="(v,i) in kycInfo.financialFileList" :key="i" :href="v.relativeUrl" target="_blank" style="display: block;color:#7996F5;"><i :class="getFileType(v.fileName)" class="file-icon"/>{{ v.fileName }}</a>
          </el-col>
        </el-row>
        <el-row >
          <el-col :span="8">{{ $t('newrisk.kyc_4') }}：</el-col>
          <el-col v-if="kycInfo.otherFileList" :span="16" style="color:#7996F5;">
            <a v-for="(v,i) in kycInfo.otherFileList" :key="i" :href="v.relativeUrl" target="_blank" style="display: block;color:#7996F5;"><i :class="getFileType(v.fileName)" class="file-icon"/>{{ v.fileName }}</a>
          </el-col>
        </el-row>
      </div>

    </el-dialog>
  </div>
</template>

<script>
import mixins from '@/helper/mixins.js'

import Tbutton from '../../components/Tbutton'
import Sbutton from '../../components/Sbutton'

import ZCollapse from '@/components/ZCollapse'

export default {
  name: 'RiskAssessment',
  components: {
    Tbutton,
    Sbutton,
    ZCollapse
  },
  mixins: [mixins],
  data() {
    return {
      source: this.$route.query.source || 0, //   来源是rongzisqs 和 financingFundDetail的rankInfo两个来源(避免点击面包屑跳转错误）   0=rongzisqs    1=rankInfo
      isShowFooter: false,
      id: this.$route.query.id || '',
      riskType: this.$route.query.riskType || '',
      infoData: {},
      infoDataDetail: {
        cicFinancingApplyDraftSnapshotVO: {
          buyerCompanyName: '',
          sellerCompanyName: ''
        }
      },
      jsonData: {
        net_profit: '',
        total_sales: '',
        total_liabilities: '',
        tangible_net_worth: '',
        tangible_net_worth_2: '',
        interest_expense: '',
        long_term_debt: '',
        short_term_debt: '',
        cash_after_operation: '',
        cash_interest_expense: '',
        cash_long_term_debt: '',
        cash_short_term_debt: '',
        activity_sales: '',
        activity_total_assets: '',
        activity_sales_thisyear: '',
        activity_sales_lastyear: '',
        liquid_assets: '',
        current_liabilities: '',
        size_net_worth: '',
        experience: {
          value: '',
          text: ''
        },
        management_strength: {
          value: '',
          text: ''
        },
        controls: {
          value: '',
          text: ''
        },
        account_conduct: {
          value: '',
          text: ''
        },
        industry_outlook: {
          value: '',
          text: ''
        },
        market_position: {
          value: '',
          text: ''
        },
        barriers_to_entry: {
          value: '',
          text: ''
        },
        cyclicality: {
          value: '',
          text: ''
        },
        risk_flexibility: {
          value: '',
          text: ''
        },
        dependencies: {
          value: '',
          text: ''
        },
        litigation: {
          value: '',
          text: ''
        },
        fx: {
          value: '',
          text: ''
        },
        country: {
          value: '',
          text: ''
        },
        market: ''
      },
      rules: {
        net_profit: [{ required: true, message: 'Fill In Required' }],
        total_sales: [{ required: true, message: 'Fill In Required' }],
        total_liabilities: [{ required: true, message: 'Fill In Required' }],
        tangible_net_worth: [{ required: true, message: 'Fill In Required' }],
        tangible_net_worth_2: [{ required: true, message: 'Fill In Required' }],
        interest_expense: [{ required: true, message: 'Fill In Required' }],
        long_term_debt: [{ required: true, message: 'Fill In Required' }],
        short_term_debt: [{ required: true, message: 'Fill In Required' }],
        cash_after_operation: [{ required: true, message: 'Fill In Required' }],
        cash_interest_expense: [{ required: true, message: 'Fill In Required' }],
        cash_long_term_debt: [{ required: true, message: 'Fill In Required' }],
        cash_short_term_debt: [{ required: true, message: 'Fill In Required' }],
        activity_sales: [{ required: true, message: 'Fill In Required' }],
        activity_total_assets: [{ required: true, message: 'Fill In Required' }],
        activity_sales_thisyear: [{ required: true, message: 'Fill In Required' }],
        activity_sales_lastyear: [{ required: true, message: 'Fill In Required' }],
        liquid_assets: [{ required: true, message: 'Fill In Required' }],
        current_liabilities: [{ required: true, message: 'Fill In Required' }],
        size_net_worth: [{ required: true, message: 'Fill In Required' }],
        'experience.value': [{ required: true, message: 'Fill In Required' }],
        'management_strength.value': [{ required: true, message: 'Fill In Required' }],
        'controls.value': [{ required: true, message: 'Fill In Required' }],
        'account_conduct.value': [{ required: true, message: 'Fill In Required' }],
        'industry_outlook.value': [{ required: true, message: 'Fill In Required' }],
        'market_position.value': [{ required: true, message: 'Fill In Required' }],
        'barriers_to_entry.value': [{ required: true, message: 'Fill In Required' }],
        'cyclicality.value': [{ required: true, message: 'Fill In Required' }],
        'risk_flexibility.value': [{ required: true, message: 'Fill In Required' }],
        'dependencies.value': [{ required: true, message: 'Fill In Required' }],
        'litigation.value': [{ required: true, message: 'Fill In Required' }],
        'fx.value': [{ required: true, message: 'Fill In Required' }],
        'country.value': [{ required: true, message: 'Fill In Required' }]
      },
      secondId: '',
      rating_type: '+',
      rating_value: '',
      suggest: '',
      remark: '',
      kycInfo: {},
      kycDialog: false
    }
  },
  created() {
    this.getInfo()
  },
  mounted() {
    document.title = this.$t('newrisk.risk_assessment')
  },

  methods: {
    openkyc() {
      this.axios.post('/api/zma/risk/getkycfilebyUsercode', { code: this.riskType == 1 ? this.infoDataDetail.cicFinancingApplyDraftSnapshotVO.buyerCode : this.infoDataDetail.cicFinancingApplyDraftSnapshotVO.sellerCode }).then(res => {
        if (res.status) {
          this.kycInfo = res.data
          this.kycDialog = true
        } else {
          this.$message.error(this.$t(`error.${res.errorCode}`))
        }
      })
    },
    numberBlur(key, num) {
      this.jsonData[key] = this.$utils.convertNum(this.jsonData[key], num)
    }, // 失去焦点 格式化数值
    moneyInput(key, type = 0) {
      this.jsonData[key] = this.$utils.dealNumber(this.jsonData[key], 2, 12, type)
    },
    moneyInput2(key, max) {
      this.jsonData[key].value = this.$utils.dealNumber(this.jsonData[key].value, 1, 2, 0)
      if (this.jsonData[key].value > max) {
        this.jsonData[key].value = max
      }
    },
    moneyInput3(key) {
      this[key] = this.$utils.dealNumber(this[key], 1, 2, 0)
      if (this.rating_type == '+') {
        if (this[key] > (100 - this.gradTotal())) {
          this[key] = 100 - this.gradTotal()
        }
      } else if (this.rating_type == '-') {
        if (this[key] > this.gradTotal()) {
          this[key] = this.gradTotal()
        }
      }
    },
    result1() {
      if (this.jsonData.net_profit !== '' && this.jsonData.total_sales > 0) {
        return ((this.jsonData.net_profit / this.jsonData.total_sales) * 100).toFixed(4) + '%'
      } else {
        return ''
      }
    },
    grad1() {
      var result = parseFloat(this.result1())
      if (result >= 9.5) {
        return 4.5
      } else if (result < 9.5 && result >= 3.3) {
        return 3.5
      } else if (result < 3.3 && result >= 1.1) {
        return 2.5
      } else if (result < 1.1 && result >= 0) {
        return 1.5
      } else if (result < 0) {
        return 0.5
      } else {
        return ''
      }
    },
    result2() {
      if (this.jsonData.total_liabilities !== '' && this.jsonData.tangible_net_worth > 0) {
        return (this.jsonData.total_liabilities / this.jsonData.tangible_net_worth).toFixed(4)
      } else {
        return ''
      }
    },
    grad2() {
      var result = parseFloat(this.result2())
      if (result >= 0.01 && result < 0.74) {
        return 6.5
      } else if (result < 1.57 && result >= 0.74) {
        return 5
      } else if (result < 2.93 && result >= 1.57) {
        return 3.5
      } else if (result < 6.2 && result >= 2.93) {
        return 2
      } else if (result < 0.01 || result >= 6.2) {
        return 0.5
      } else {
        return ''
      }
    },
    result3() {
      if (this.jsonData.tangible_net_worth_2 !== '' && (Number(this.jsonData.interest_expense) + Number(this.jsonData.long_term_debt) + Number(this.jsonData.short_term_debt)) > 0) {
        return (this.jsonData.tangible_net_worth_2 / (Number(this.jsonData.interest_expense) + Number(this.jsonData.long_term_debt) + Number(this.jsonData.short_term_debt))).toFixed(4)
      } else {
        return ''
      }
    },
    grad3() {
      var result = parseFloat(this.result3())
      if (result >= 18.16) {
        return 6.5
      } else if (result < 18.16 && result >= 3.89) {
        return 5
      } else if (result < 3.89 && result >= 1.32) {
        return 3.5
      } else if (result < 1.32 && result >= 0.3) {
        return 2
      } else if (result < 0.3) {
        return 0.5
      } else {
        return ''
      }
    },
    result4() {
      if (this.jsonData.cash_after_operation !== '' && (Number(this.jsonData.cash_interest_expense) + Number(this.jsonData.cash_long_term_debt) + Number(this.jsonData.cash_short_term_debt)) > 0) {
        return (this.jsonData.cash_after_operation / (Number(this.jsonData.cash_interest_expense) + Number(this.jsonData.cash_long_term_debt) + Number(this.jsonData.cash_short_term_debt))).toFixed(4)
      } else {
        return ''
      }
    },
    grad4() {
      var result = parseFloat(this.result4())
      if (result >= 16.63) {
        return 10
      } else if (result < 16.63 && result >= 3.91) {
        return 8
      } else if (result < 3.91 && result >= 1.13) {
        return 6
      } else if (result < 1.13 && result >= 0.1) {
        return 4
      } else if (result < 0.1) {
        return 2
      } else {
        return ''
      }
    },
    result5() {
      if (this.jsonData.activity_sales !== '' && this.jsonData.activity_total_assets > 0) {
        return (this.jsonData.activity_sales / this.jsonData.activity_total_assets).toFixed(4)
      } else {
        return ''
      }
    },
    grad5() {
      var result = parseFloat(this.result5())
      if (result >= 2.21) {
        return 4.5
      } else if (result < 2.21 && result >= 1.27) {
        return 3.5
      } else if (result < 1.27 && result >= 0.78) {
        return 2.5
      } else if (result < 0.78 && result >= 0.34) {
        return 1.5
      } else if (result < 0.34) {
        return 0.5
      } else {
        return ''
      }
    },
    result6() {
      if (this.jsonData.activity_sales_thisyear !== '' && this.jsonData.activity_sales_lastyear > 0) {
        return (((this.jsonData.activity_sales_thisyear / this.jsonData.activity_sales_lastyear) - 1) * 100).toFixed(4) + '%'
      } else {
        return ''
      }
    },
    grad6() {
      var result = parseFloat(this.result6())
      if (result >= 1 && result < 11) {
        return 4
      } else if (result < 1 && result >= -17) {
        return 3
      } else if (result < 38 && result >= 11) {
        return 2
      } else if (result < -17) {
        return 1
      } else if (result >= 38) {
        return 0
      } else {
        return ''
      }
    },
    result7() {
      if (this.jsonData.liquid_assets !== '' && this.jsonData.current_liabilities > 0) {
        return (this.jsonData.liquid_assets / this.jsonData.current_liabilities).toFixed(4)
      } else {
        return ''
      }
    },
    grad7() {
      var result = parseFloat(this.result7())
      if (result >= 18) {
        return 11
      } else if (result < 18 && result >= 6) {
        return 8.8
      } else if (result < 6 && result >= 3) {
        return 6.6
      } else if (result < 3 && result >= 1) {
        return 4.4
      } else if (result < 1) {
        return 2.2
      } else {
        return ''
      }
    },
    grad8() {
      var result = this.jsonData.size_net_worth
      if (this.jsonData.size_net_worth !== '') {
        if (result >= 90) {
          return 3
        } else if (result < 90 && result >= 20) {
          return 2.4
        } else if (result < 20 && result >= 2) {
          return 1.8
        } else if (result < 2 && result >= 0) {
          return 1.2
        } else if (result < 0) {
          return 0.6
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    grad9() {
      return Number(this.jsonData.experience.value) + Number(this.jsonData.management_strength.value) + Number(this.jsonData.controls.value) + Number(this.jsonData.account_conduct.value)
    },
    grad10() {
      return (Number(this.jsonData.industry_outlook.value) + Number(this.jsonData.market_position.value) + Number(this.jsonData.barriers_to_entry.value) + Number(this.jsonData.cyclicality.value) + Number(this.jsonData.risk_flexibility.value) + Number(this.jsonData.dependencies.value)).toFixed(2)
    },
    grad11() {
      return Number(this.jsonData.litigation.value) + Number(this.jsonData.fx.value) + Number(this.jsonData.country.value)
    },
    gradTotal() {
      return Number(this.grad1()) + Number(this.grad2()) + Number(this.grad3()) + Number(this.grad4()) + Number(this.grad5()) + Number(this.grad6()) + Number(this.grad7()) + Number(this.grad8()) + Number(this.grad9()) + Number(this.grad10()) + Number(this.grad11())
    },
    ratingLevel() {
      if (this.rating_type == '+') {
        return (this.gradTotal() + Number(this.rating_value)).toFixed(2)
      } else if (this.rating_type == '-') {
        return (this.gradTotal() - this.rating_value).toFixed(2)
      }
    },
    submit1() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          var paranms = {}
          this.infoData.id ? paranms = { id: this.infoData.id, flowNumber: this.id, riskType: this.riskType, riskValue: JSON.stringify(this.jsonData) } : paranms = { flowNumber: this.id, riskType: this.riskType, riskValue: JSON.stringify(this.jsonData) }
          this.axios.post('/api/zma/risk/saveriskdetail', paranms).then(res => {
            if (res.status) {
              this.isShowFooter = true
            } else {
              this.$message.error(this.$t(`error.${res.errorCode}`))
            }
          })
        } else {
          return false
        }
      })
    },
    submit2() {
      var paranms = {
        flowNumber: this.id,
        ratingLoanId: this.infoDataDetail.zmaFinancingManagementVO.loanId,
        code: this.infoDataDetail.cicFinancingApplyDraftSnapshotVO.buyerCode, // sellerCode
        rateType: this.riskType == 3 ? 1 : 3, // 1.客户评级  3 类目
        operaScore: this.rating_type == '+' ? Number(this.rating_value) : Number('-' + this.rating_value),
        ratingLevelnew: this.ratingLevel(),
        remark: this.remark,
        suggest: this.suggest ? this.suggest : 0,
        supplierType: this.riskType == 1 ? 1 : 2// '1 买  2 卖'
      }
      if (this.secondId) {
        paranms.id = this.secondId
      }

      this.axios.post('/api/zma/risk/savesecond', paranms)
      this.isShowFooter = false
    },
    getInfo() {
      this.axios.post('/api/zma/risk/getriskdetail', { flowNumber: this.id, riskType: this.riskType }).then(res => {
        if (res.status) {
          if (res.data.length > 0) {
            this.infoData = res.data[0]
            this.jsonData = JSON.parse(res.data[0].riskValue)
          }
        } else {
          this.$message.error(this.$t(`error.${res.errorCode}`))
        }
      })
      var params = { flowNumber: this.id }
      if (this.riskType == 3) {
        params.supplierType = 2
        params.rateType = 3
      } else if (this.riskType == 2) {
        params.supplierType = 2
      } else if (this.riskType == 1) {
        params.supplierType = 1
      }
      this.axios.post('/api/zma/risk/getsecond', params).then(res => {
        if (res.status) {
          if (res.data) {
            this.secondId = res.data.id
            this.rating_type = res.data.operaScore < 0 ? '-' : '+'
            this.rating_value = Math.abs(res.data.operaScore)
            this.suggest = res.data.suggest > 0 ? res.data.suggest : ''
            this.remark = res.data.remark
          }
        } else {
          this.$message.error(this.$t(`error.${res.errorCode}`))
        }
      })
      this.axios.post('/api/zma/risk/zmaRiskDetail', { flowNumber: this.id }).then(res => {
        if (res.status) {
          this.infoDataDetail = res.data
        } else {
          this.$message.error(this.$t(`error.${res.errorCode}`))
        }
      })
    }

  }
}
</script>

<style lang="scss">

.toList-popper.el-popover{
  max-height: 300px;
  max-width: 560px;
  overflow-x: hidden;
  overflow-y: auto;
  min-width: auto;
  background: #FFFFFF;
box-shadow: 0px 0px 10px 0px #EAEAEA;
border: 1px solid #DDDDDD;
font-size: 14px;
font-weight: 400;
color: #666666;
line-height: 22px;
}
</style>
<style lang="scss" scoped>
.model-input{
    height: 36px;
    line-height: 36px;
    width: 170px;
    padding: 0 15px;
}
.model-input-2{
    display: inline-block;
    // height: 36px;
    line-height: 1;
    width: 80px;
    padding: 0 15px;
    overflow: hidden;
    margin-right: 10px;
}
.model-input-3{
    display: inline-block;
    box-sizing: border-box;
    // height: 36px;
    line-height:1;
    width: 386px;
    padding: 0 15px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
*{
  box-sizing: border-box;
}
::v-deep .el-tabs__item{
    padding:0 90px !important;
}
::v-deep .el-input__icon{
  line-height: 36px;
}
.theme-default{
  ::v-deep .el-tabs__content{
    padding:20px 90px;
  }
}

.company-name{
  font-size: 18px;
  color: #7996F5;
  line-height: 25px;
  cursor: pointer;
  padding-left: 90px;
}
.mt--20{
  margin-top: -20px;
}
.collapse-box{
  color: #333;
  padding: 20px 0;
  display: flex;
  justify-content: space-between;
  .left-box{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    max-width: 220px;
    .tit{
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 16px;
    }
    .core{
      height: 50px;
      width: 200px;
      background: #F1F4FE;
      border-radius: 2px;
      justify-content: center;
      display: flex;
      line-height: 50px;
      .s1{
        font-size: 14px;color: #666666;margin-right:10px;
      }
      .s2{
        font-size: 28px;color: #4C75FC;line-height: 44px;
      }
      .s3{
        font-size: 20px;color: #4C75FC;
      }
    }
  }
  .right-box{
    width: 780px;
    background: #F5F7FA;
    border-radius: 1px;
    padding: 20px;
    padding-top: 0;
    padding-right: 0;
    display: flex;
    flex-wrap: wrap;
    .mt-20{
      margin-top: 20px;
    }
    .item{
      margin-top: 20px;
      margin-right: 20px;
      .el-form-item{
        margin-bottom: 0;
      }
      .tit{
        font-size: 14px;
        color: #81899E;
        padding-left: 15px;
        margin-bottom: 10px;
      }
      ::v-deep .el-input__inner{
        width: 170px;
        height: 36px;
      }
      ::v-deep .el-input.is-disabled {
        .el-input__inner{
          color: #606268;
        }

        }
    }
  }
}
.collapse-box2{
  color: #333;
  padding: 20px 0;
  display: flex;
  border-bottom: 1px solid #EAEAEA;
  justify-content: space-between;

  .left-box{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    max-width: 220px;
    .tit{
      font-size: 14px;
      line-height: 20px;
    }
    .core{
      height: 50px;
      width: 200px;
      background: #F1F4FE;
      border-radius: 2px;
      justify-content: center;
      display: flex;
      line-height: 50px;
      .s1{
        font-size: 14px;color: #666666;margin-right:10px;
      }
      .s2{
        font-size: 28px;color: #4C75FC;line-height: 44px;
      }
      .s3{
        font-size: 20px;color: #4C75FC;
      }
    }
  }
  .right-box{
    width: 780px;
    background: #F5F7FA;
    border-radius: 1px;
    padding: 20px;
    .mt-10{
      margin-top: 20px;
    }

    .item{
      display: flex;
      justify-content: space-between;
      .el-form-item{
        flex: 1;
        margin-bottom: 0;
       ::v-deep .el-form-item__content{
          line-height: 1;
        }
      }
      .tit{
        font-size: 14px;
        color: #81899E;
        margin-right: 10px;
        width: 254px;
        line-height: 1;
      }
      .input-1{
        width: 80px;
        margin-right: 10px;
        vertical-align: top;
      }
      .input-2{
        width: 386px;
        ::v-deep .el-textarea__inner{
          min-height: 36px !important;
        }
      }
      ::v-deep .el-input__inner{
        height: 36px;
      }
    }
  }
}
.tab-3{
    display: flex;
    .score-box{
        width: 160px;
        height: 160px;
        background: #F1F4FE;
        border-radius: 2px;
        font-size: 40px;
        color: #4C75FC;
        line-height: 160px;
        text-align: center;
        flex-shrink: 0;
    }
    .row{
      flex: 1;
        display: flex;
        .s-1{
            flex-shrink: 0;
            width: 52px;
            color: #7996f5;
        }
        .s-2{
            flex: 1;
            line-height: 20px;
        }
    }
}
.whiteFixed {
  position: fixed;
  text-align: center;
  border-top: 1px solid #eaeaea;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100px;
  line-height: 100px;
  background: #ffffff;
  z-index: 99;
  margin-top: 70px;
}
.tip1{
  color: #333;
  font-size: 14px;
  line-height: 20px;
  margin-top:20px ;
  margin-bottom: 10px;
}
.tip2{
  color: #333;
  font-size: 14px;
  line-height: 20px;

}
.rating-1{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  .rating-box{
    width: 136px;
    height: 80px;
    background: #F1F4FE;
    border-radius: 2px;
    color: #4C75FC;
    font-size: 28px;
    text-align: center;
    line-height: 80px;
  }
}
.rating-2{
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
::v-deep.el-dialog {
    .el-dialog__close {
      width: 14px;
      height: 14px;
      color: #fff;
    }

    .el-dialog__header {
      background: #40404d;
      height: 70px;
      padding: 0;
      text-align: center;
      line-height: 70px;
      font-size: 18px;
      .el-dialog__title {
        color: #ffffff !important;
        font-family: PingFangSC-Regular;
      }
    }
    .el-dialog__body {
      padding: 0;

      .el-input__inner {
        height: 36px;
      }
    }
  }
  .addMoneySpan {
  box-sizing: border-box;
  display: block;
  text-align: center;
  width: 670px;
  height: 70px;
  box-shadow: inset 0 1px 0 0 #eaeaea;
  margin: 0 auto;
  padding-top: 16px;
}
.pool-btn-primary {
  width: 150px;
  height: 38px;
  background: #7996f5;
  border-radius: 2px;
  color: #fff;
}
.pool-btn-default {
  width: 150px;
  height: 38px;
  background: #ffffff;
  border: 1px solid #7996f5;
  border-radius: 2px;
  color: #7996f5;
}
.profile-div{
  .file-icon{
    display: inline-block;
    width: 20px;
    height: 19px;
    vertical-align: middle;
    margin-right: 11px;
  }
}
</style>
